// import config from 'config';

/* eslint-disable */
import { authHeader } from '../_helpers';
import axios from 'axios';
import {V1API} from "../_helpers/APIPath";
import UserAuth from "@/auth/js";
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const userService = {
    login,
    logout,
    verify,
    // getAll
};

async function login(email, password) {
    let data = {
        "email": email,
        "password": password
    };

    let response = await axios.post(V1API.getAccessToken, data).then(user=> {
        if (user.data.access_token) {
            // console.log(user.data.permissions)
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(user.data));
            localStorage.setItem("access_token", user.data.access_token);
            localStorage.setItem("refresh_token", user.data.refresh_token);
            localStorage.setItem("permissions", JSON.stringify(user.data.permissions));
            localStorage.setItem('reloaded', 'no')
            return user
        } else {
            let error = user
            return error
        }
    }).catch(function (error) {
        return error;
    });

    return response
}

async function verify(access_token) {
    let data = {
       access_token:access_token
    };

    let response = await axios.post(V1API.verifyLogin, data).then(data=> {
        if (data.data.code == 200){
            console.log('access token verified')
            return true
        } else {
            verifyRefresh()
        }
    }).catch(function (error) {
        return error;
    });
    
    return response
}

// Get user location
async function getUserLocation() {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) return reject('Geolocation not supported');

        navigator.geolocation.getCurrentPosition(
            (position) => {
                resolve({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
            },
            (error) => reject(error.message)
        );
    });
}

// Get user IP address
async function getUserIP() {
    try {
        const res = await fetch('https://api.ipify.org?format=json');
        const data = await res.json();
        return data.ip;
    } catch (e) {
        return null;
    }
} 

// Device Fingerprinting
async function getDeviceFingerprint() {
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  return result.visitorId; // a unique ID based on device/browser
}

async function getFingerprintValue() {
    const fingerprint = await getDeviceFingerprint();
    console.log(fingerprint); // ✅ Outputs the string
    return fingerprint;
}


// async function verifyRefresh() {
//     try {
//         const [ip, location] = await Promise.all([
//             getUserIP(),
//             getUserLocation().catch(() => null) // in case user denies location access
//         ]);

//         const refresh_data = {
//             refresh_token: localStorage.getItem("refresh_token"),
//             ip_address: ip,
//             location: location ? `${location.latitude},${location.longitude}` : null
//         };

//         const response = await axios.post(V1API.refreshAccessToken, refresh_data);

//         if (response.data.code == 200) {
//             console.log('refresh token verified');
//             localStorage.setItem("access_token", response.data.access_token);
//             localStorage.setItem("refresh_token", response.data.refresh_token);
//             window.location.reload();
//             return true;
//         } else {
//             logout();
//             window.location.reload();
//             return false;
//         }
//     } catch (error) {
//         return error;
//     }
// }

async function verifyRefresh() {
    let refresh_data = {
        refresh_token: localStorage.getItem("refresh_token")
    }

    let response = await axios.post(V1API.refreshAccessToken, refresh_data).then(data=> {
        if (data.data.code==200){
            console.log('refresh token verified')
            localStorage.setItem("access_token", data.data.access_token);
            localStorage.setItem("refresh_token", data.data.refresh_token);
            window.location.reload()
            return true

        } else {
            window.location.reload()
            logout()
            return false
        }
    }).catch(function (error) {
        return error;
    });

    return response
}

function logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('access_token');
    localStorage.removeItem('permissions');
    localStorage.removeItem('reloaded');
}

// function getAll() {
//     const requestOptions = {
//         method: 'GET',
//         headers: authHeader()
//     };
//
//     return fetch(`http://localhost:8080/users`, requestOptions).then(handleResponse);
// }

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
